/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    Transaction,
    TransactionFromJSON,
    TransactionFromJSONTyped,
    TransactionToJSON,
    TransactionListAllOf,
    TransactionListAllOfFromJSON,
    TransactionListAllOfFromJSONTyped,
    TransactionListAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface TransactionList
 */
export interface TransactionList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof TransactionList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof TransactionList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof TransactionList
     */
    transactions: Array<Transaction>;
}

export function TransactionListFromJSON(json: any): TransactionList {
    return TransactionListFromJSONTyped(json, false);
}

export function TransactionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'transactions': ((json['transactions'] as Array<any>).map(TransactionFromJSON)),
    };
}

export function TransactionListToJSON(value?: TransactionList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'transactions': ((value.transactions as Array<any>).map(TransactionToJSON)),
    };
}


